module.exports = __webpack_public_path__ + "media/images/emblems/Oberhuenigen-coat_of_arms-57648ed1bf7bae468e9e450e65614fd8.svg";